module.exports = __webpack_public_path__ + "img/pr-1.ac25bffc.png";